import { createContext as e, useContext as t } from "react";
var l = /*#__PURE__*/e({
    onOptionClick: null,
    value: null,
    isOpen: !1,
    setIsOpen: null,
    preventCloseOnSelect: !1
  }),
  o = function o() {
    return t(l);
  };
export { l as default, o as useSelectContext };